export default function createStoreModule() {
    return {
        namespaced: true,
        state: () => ({
            userId: null,
        }),
        mutations: {
            setAmplitudeUserId(state, data) {
                state.userId = data;
            },
        },
        getters: {
            userId: state => state.userId,
        },
    };
}
